var _defs, _path, _path2, _path3, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 371.31 542.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#201f20;}.cls-2{fill:#f7f0f0;stroke:#020202;stroke-miterlimit:10;stroke-width:0.25px;}.cls-3{fill:#202022;}.cls-4{fill:#eae8e8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M442.47,544.34c-94.83,3-195.61,8.55-290.43,11.55-34.72,0-62.86-26.27-62.86-58.67V72.2c0-32.4,28.14-58.67,62.86-58.67H449.55c0,135.58-4,286.47-7.08,440.67",
    transform: "translate(-89.18 -13.53)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.87,510.26l-247.16,7.82c-11.85,0-22.46-7.06-26.07-17.6a33.43,33.43,0,0,1-1.93-10.75v-2.12c0-15.57,13.52-28.2,30.2-28.2l245-5.21Z",
    transform: "translate(-89.18 -13.53)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.65,34.83,443.58,24.65a1.71,1.71,0,0,1,1.81,1.58l15.1,421.35a.63.63,0,0,1-.63.63l-327,10.21Z",
    transform: "translate(-89.18 -13.53)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 104.76,
    y: 153.16,
    width: 157.33,
    height: 27.38
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 104.76,
    y: 218.05,
    width: 157.33,
    height: 27.38
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.fd53b44a.svg";
export { ForwardRef as ReactComponent };